import Chip from '@material-ui/core/Chip';
import styles from './catalogStatus.module.css';

type StatusTone = 'success' | 'building' | 'failed' | 'other';

function toneClass(tone: StatusTone): string {
  switch (tone) {
    case 'success':
      return styles.statusSuccess;
    case 'building':
      return styles.statusBuilding;
    case 'failed':
      return styles.statusFailed;
    default:
      return styles.statusOther;
  }
}

/**
 * Normalize infra / image-build status annotations into chip label + tone.
 * - Image builds: building | success | failed
 * - Stacks / launches: provisioning | active | failed
 */
export function resolveInfraStatusChip(raw?: string): {
  label: string;
  tone: StatusTone;
} | null {
  if (!raw?.trim()) {
    return null;
  }
  const normalized = raw.trim().toLowerCase();

  if (normalized === 'success' || normalized === 'active') {
    return { label: 'Ready', tone: 'success' };
  }
  if (normalized === 'building' || normalized === 'provisioning') {
    return { label: 'Building', tone: 'building' };
  }
  if (
    normalized === 'failed' ||
    normalized === 'failure' ||
    normalized === 'error'
  ) {
    return { label: 'Error', tone: 'failed' };
  }

  return { label: raw, tone: 'other' };
}

export function InfraStatusChip({ status }: { status?: string }) {
  const resolved = resolveInfraStatusChip(status);
  if (!resolved) {
    return <span>-</span>;
  }
  return (
    <Chip
      size="small"
      label={resolved.label}
      className={`${styles.statusChip} ${toneClass(resolved.tone)}`}
    />
  );
}
